import React from "react";
import cleveronImg from "../../images/cleveronImg.png";
import {useTranslation} from "react-i18next";

const CleveronCard = ({cleveronDetails}) => {
  const {t} = useTranslation();
  const locationProducts = cleveronDetails?.locationsOfProduct || [];
  const numberProducts = cleveronDetails?.numberOfProducts || 0;
  return (
    <div className="bg-white rounded-[16px] shadow-md p-6 w-full max-w-[360px] mx-auto text-center space-y-6 h-[85%] font-[Lato,sans-serif]">
      <div className="space-y-2 mt-6">
        <div className="text-[#333333] text-[24px] font-bold leading-[120%] text-center">
          {`¡Tu${
            numberProducts > 1
              ? t("cleveronHeader1Plural")
              : t("cleveronHeader1Singular")
          }`}
          <br />
          {`${t(
            numberProducts > 1
              ? "cleveronHeader2Plural"
              : "cleveronHeader2Singular"
          )} ${locationProducts.join(" y ")}!`}
        </div>
        <div className="text-[#333333] text-[17px] font-normal leading-[150%] mt-2">
          {t("cleveronSubHeader1")}{" "}
          <span className="font-bold">{t("qrCode")}</span>,<br />
          {t("cleveronSubHeader2")}
        </div>
      </div>
      <div className="flex justify-center">
        <img
          src={cleveronImg}
          alt="Módulo de retiro"
          className="w-[140px] mt-4 mb-6"
        />
      </div>
      <div className="text-[#666666] text-[17px] font-normal leading-[150%] mt-6">
        {t("cleveronFooter1")}
        <br />
        {t("cleveronFooter2")}
      </div>
    </div>
  );
};

export default CleveronCard;
